import {
  Component,
  HostListener,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  ChatItemDetailsDto,
  createItemDetails,
} from '../../../data/models/dto/chat-item-details.dto';
import { RoomDto } from '../../../data/models/dto/room.dto';
import { UserInfoDto } from '../../../data/models/dto/user-info.dto';
// factory
import {
  createUserHeaderDto,
  createUserHeaderDtoToRoom,
} from './../../../data/factory/user-header-dto.factory';
import { DIRECTOR_PROFILES, RESTRICTED_ROUTE_PROFILES } from '../../../data/utils/profile.utils';
// components

@Component({
  selector: 'app-chats',
  templateUrl: './chats.component.html',
  styleUrls: ['./chats.component.scss'],
})
export class ChatsPageComponent implements OnInit, OnChanges {

  profilesElegibleToManageChats = RESTRICTED_ROUTE_PROFILES(DIRECTOR_PROFILES);

  itemDetails: ChatItemDetailsDto | undefined;
  idUserDetails: string | string[] | undefined;

  showInitalMessage: boolean = true;
  screenWidth: number = 0;
  screenHeight: number = 0;

  showUserDetails: boolean = false;
  showOnlyDetails: boolean = false;
  showOnlyMessages: boolean = false;
  showAll: boolean = false;
  isMobile: boolean = false;
  isRoom: boolean = false;

  loadingList: boolean = true;
  existMessage: boolean = false;

  showArchived = false;
  showActiveTickets = false;

  constructor(private router: Router) {}

  get showDetailsText(): boolean {
    return !this.isRoom && !this.showUserDetails;
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;

    this.updateChatScreen();
  }

  ngOnInit() {
    this.getScreenSize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.loadingMessageList(event);
      this.chatStatus(event);
    }
  }

  updateChatScreen() {
    if (this.screenWidth <= 800) {
      this.showOnlyMessages = true;
      this.showOnlyDetails = false;
      this.showAll = false;
      this.isMobile = true;
    } else {
      this.showAll = true;
      this.isMobile = false;
    }
  }

  getRoomFromChatMessages(room: RoomDto) {
    this.closeUserDetails();
    this.isRoom = true;
    this.updateChatScreen();

    const headerDto = createUserHeaderDtoToRoom(
      room.id,
      true,
      room.members,
      room.name,
      '../../../assets/icons/icon-canais.svg',
      '',
      room.alias,
      room.ticketFunctionalityActive
    );
    this.itemDetails = createItemDetails(
      true,
      room.id,
      undefined,
      undefined,
      headerDto,
      room.ticketFunctionalityActive
    );

    if (this.screenWidth <= 800) {
      const params = {
        idRoom: room.id,
        navTitle: room.name,
        headerDto: headerDto,
      };
      this.router.navigate(['/chat-details', JSON.stringify(params)]);
    }
  }

  getUserFromChatMessages(user: UserInfoDto) {
    this.closeUserDetails();
    this.isRoom = false;
    this.updateChatScreen();

    //TODO: Adicionar profile ao endpoint do chat
    const headerDto = createUserHeaderDto(
      user.id,
      false,
      user.firstName + ' ' + user.lastName,
      user.photo,
      ''
    );

    this.itemDetails = createItemDetails(
      false,
      undefined,
      user.id,
      headerDto.name,
      headerDto,
      undefined
    );

    if (this.screenWidth <= 800) {
      const params = {
        idDestUser: user.id,
        navTitle: headerDto.name,
        headerDto: headerDto,
      };
      this.router.navigate(['/chat-details', JSON.stringify(params)]);
    }
  }

  openUserDetails(id: string | string[]) {
    if (id && id != '') {
      this.idUserDetails = id;
      this.showUserDetails = true;
      this.isRoom = false;
    } else {
      this.idUserDetails = '';
      this.showUserDetails = false;
      this.isRoom = false;
    }
  }

  closeUserDetails() {
    this.showUserDetails = false;
  }

  navigateToChannels() {
    this.router.navigateByUrl('/channels');
  }

  removeInitalMessage() {
    this.showInitalMessage = false;
  }

  loadingMessageList(evt: any) {
    this.loadingList = evt;
  }

  chatStatus(evt: any) {
    this.existMessage = evt;
  }
}
